 $(document).ready(function(){ 
      $('.marquee').marquee({
         gap: 50,
          delayBeforeStart: 0, 
          duplicated: true,
          pauseOnHover: true
      });
    
    $('.wavelength').find('li').each(function() {
       var bullet = $(this).attr('data-rate'); 
        if(bullet > 0){
          $(this).append('<div class="dot-holder"></div>');
           for(i = 1; i <= 10; i++){
             if( i <= bullet){ 
               $(this).children('.dot-holder').append('<span class="full-dot"></span>'); 
             }else{ 
               $(this).children('.dot-holder').append('<span></span>'); 
             }
           }
        }
        
    });   

   $('.rash-item_toggler').click(function(){
     $(this).toggleClass('active'); 
     var item_target = $(this).attr('data-target'); 
     $(item_target).slideToggle().toggleClass('active'); 
   }); 

 /*
   $(".header__icon--menu").click(function() {
      var detailsElement = $('#Details-HeaderMenu-1'); 
        
        detailsElement.prop('open', true); 
    });
*/
  
}); 

document.addEventListener('DOMContentLoaded', function () {
  const detailsElements = document.querySelectorAll('header-menu details');

  function updateAriaExpanded(details) {
    const isOpen = details.open; // Checks the open property of the details element
    details.querySelector('summary').setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  detailsElements.forEach(details => {
    // Initialize aria-expanded based on the open property
    updateAriaExpanded(details);

    details.querySelector('summary').addEventListener('click', function (event) {
      // Prevent the default toggle behavior to manually manage it
      event.preventDefault();

      // Close all other details that are open
      detailsElements.forEach(otherDetails => {
        if (otherDetails !== details && otherDetails.open) {
          otherDetails.open = false;
          updateAriaExpanded(otherDetails);
        }
      });

      // Toggle the open property of the clicked details
      details.open = !details.open;
      updateAriaExpanded(details);
    });
  });
});